import { CommonModule } from '@angular/common';
import { Component, inject, Injector, OnInit } from '@angular/core';
import {
  SupplierReturnNoteListDto,
  SupplierReturnNoteService,
} from '@digiwall/goliath-documents/proxy';
import {
  DwGridDataSourceService,
  FieldTypes,
  IEnumerationCellRendererParams,
} from '@digiwall/ag-grid';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';
import { BaseSupplierDocList } from '../../base-supplier-docs/base-supplier-doc-list';

@Component({
  selector: 'document-supplier-return-note-list',
  templateUrl: './supplier-return-note-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class SupplierReturnNoteListComponent
  extends BaseSupplierDocList<SupplierReturnNoteListDto, SupplierReturnNoteService>
  implements OnInit
{
  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'receivedDate',
      headerName: this.localizationService.instant('Doc::SupplierReturnNote:ReceivedDate'),
      type: FieldTypes.Date,
    },
    {
      field: 'returnStatus',
      headerName: this.localizationService.instant('Doc::SupplierReturnNote:SupplierReturnStatus'),
      type: FieldTypes.Enumeration,
      cellRendererParams: {
        entities: this.documentEnumerationTypeStore.supplierReturnStatus,
      } as IEnumerationCellRendererParams,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    supplierReturnNoteService: SupplierReturnNoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      supplierReturnNoteService,
      router,
      route,
      confirmation,
      localizationService,
      subscriptionService,
      datasource,
      injector,
    );
  }
}
